module.exports = __webpack_public_path__ + "static/media/ironfist.8959bbdc.png";